import { lazy } from "react";
// Clinical Notes (generación previa a clinical-notes-v2). Publica la página de
// creación por template montada en /CreateClinicalNotePage.
const ClinicalNotesPage = lazy(() => import("./pages/ClinicalNotesPage"));
export const clinicalNotesRoutes = [
  { path: "/CreateClinicalNotePage", element: <ClinicalNotesPage /> },
];

export { ClinicalNotesPage };
